import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { AuctionView } from "src/app/articles-manager/interfaces/auction.interface";

type AuctionViewWithDate = AuctionView & {
  startDateViewDate: Date;
  endDateViewDate: Date;
  isStartedOnFuture: boolean;
  isEndedOnFuture: boolean;
  deltaMillisToEnd: number;
  deltaMillisToStart: number;
};

@Pipe({ name: "sortAuctions" })
export class SortAuctionsPipe implements PipeTransform {
  millisecondsInASecond = 1000;
  hoursInADay = 24;
  minutesInAHour = 60;
  secondsInAMinute = 60;
  millisecondsInADay =
    this.millisecondsInASecond *
    this.minutesInAHour *
    this.secondsInAMinute *
    this.hoursInADay;

  private transformDate(date: string): Date {
    return new Date(new DatePipe("en-US").transform(date, "MM/dd/yyyy HH:mm"));
  }

  transform(auctionViewList: AuctionView[]): AuctionView[] {
    const typedAuctionViewList = auctionViewList as AuctionViewWithDate[];

    const now = new Date().getTime();

    typedAuctionViewList.forEach((auction) => {
      const startDate = this.transformDate(auction.startDate);
      const endDate = this.transformDate(auction.endDateView);

      auction.startDateViewDate = startDate;
      auction.endDateViewDate = endDate;
      auction.deltaMillisToEnd = startDate.getTime() - now;
      auction.deltaMillisToStart = endDate.getTime() - now;
      auction.isStartedOnFuture = auction.deltaMillisToStart > 0;
      auction.isEndedOnFuture = auction.deltaMillisToEnd > 0;
    });

    return auctionViewList.sort((a, b) =>
      this._compareAuctions(a as AuctionViewWithDate, b as AuctionViewWithDate)
    );
  }

  private _compareAuctions(a: AuctionViewWithDate, b: AuctionViewWithDate) {
    const aExpiringStatus = this._getExpiringStatus(a);
    const bExpiringStatus = this._getExpiringStatus(b);

    if (aExpiringStatus === bExpiringStatus) {
      return this._compareAuctionsByEvidence(a, b);
    }

    return bExpiringStatus - aExpiringStatus;
  }

  private _compareAuctionsByEvidence(
    a: AuctionViewWithDate,
    b: AuctionViewWithDate
  ) {
    if (a.evidenceLevel === b.evidenceLevel) {
      return this._compareAuctionsByEndDate(a, b);
    }

    return b.evidenceLevel - a.evidenceLevel;
  }

  private _compareAuctionsByEndDate(
    a: AuctionViewWithDate,
    b: AuctionViewWithDate
  ) {
    if (a.isEndedOnFuture && b.isEndedOnFuture) {
      return b.deltaMillisToEnd - a.deltaMillisToEnd;
    } else if (!a.isEndedOnFuture && !b.isEndedOnFuture) {
      return a.deltaMillisToEnd - b.deltaMillisToEnd;
    }
    return 0;
  }

  private _getExpiringStatus(auction: AuctionViewWithDate): number {
    if (!auction.isStartedOnFuture) {
      const daysToEnd = auction.deltaMillisToEnd / this.millisecondsInADay;
      if (daysToEnd <= 0 && auction.isFinished) {
        return -1;
      }
      if (daysToEnd < 1 && !auction.isFinished) {
        return 1;
      }
    }
    return 0;
  }

}
